import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import AuthCodeInput from './AuthCodeInput';

const styles = () => ({
  root: {},
});

const MultiFactorAuthenticationCodeInput = ({
  className,
  classes,
  inputProps,
  InputProps,
  ...rest
}) => {
  return (
    <TextField
      className={classNames(classes.root, className)}
      inputProps={{
        autoComplete: 'off',
        autoCorrect: 'false',
        spellCheck: 'false',
        ...inputProps,
      }}
      /* eslint-disable-next-line react/jsx-no-duplicate-props */
      InputProps={{
        inputComponent: AuthCodeInput,
        ...InputProps,
      }}
      {...rest}
    />
  );
};

MultiFactorAuthenticationCodeInput.defaultProps = {
  className: '',
};

MultiFactorAuthenticationCodeInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MultiFactorAuthenticationCodeInput);
